import { useQuery } from '@tanstack/react-query';
import { LoginAttemptsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useLoginAttemptsControllerGetLoginAttemptsQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['loginAttemptsControllerGetLoginAttempts', accessControlScope, args],
        queryFn: async () => {
            const api = new LoginAttemptsApi(accessControlConfig);
            return api.loginAttemptsControllerGetLoginAttempts(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useLoginAttemptsControllerGetLoginAttemptsQuery.js.map